import { useUserQuery } from './useUserQuery';
export const useSettingsQuery = () => {
    const { user } = useUserQuery();
    if (user) {
        return user?.settings || {};
    }
    return {};
};
//# sourceMappingURL=useSettingsQuery.js.map